import React from "react";
import { Skeleton } from "@mui/material";

export function CardSkeleton() {
  return (
    <div
      style={{
        flex: "1 1 280px",
        maxWidth: "340px",
        minWidth: "260px",
        borderRadius: "16px",
        border: "1px solid #d0d0d0",
        backgroundColor: "#fff",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <Skeleton variant="text" width="60%" height={28} animation="wave" />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={80}
        animation="wave"
      />
      <Skeleton variant="text" width="40%" animation="wave" />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={40}
        animation="wave"
        style={{ borderRadius: 8 }}
      />
    </div>
  );
}

type ListProps = {
  count?: number;
};

export function CardListSkeleton({ count = 3 }: ListProps) {
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "24px",
        justifyContent: "center",
        width: "100%",
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <CardSkeleton key={index} />
      ))}
    </div>
  );
}
